import React from 'react';

const NotificationsPage = () => (
	<div>
		Notifications page
	</div>
);

export default NotificationsPage;